import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import {
  resetRegisterEditProfileForm,
  resetChangeEmailForm,
  resetChangePasswordForm,
  changeEmail,
  changePassword
} from 'actions/authActions';
import { updateProfile } from 'actions/profileActions';
import EditProfileForm from './editProfileForm';
import EditProfileSuccess from './editProfileSuccess';

@connect(
  state => ({
    auth: state.auth,
    profile: state.profile
  }),
  {
    updateProfile,
    resetRegisterEditProfileForm,
    resetChangeEmailForm,
    resetChangePasswordForm,
    changeEmail,
    changePassword
  }
)
export default class EditProfile extends Component {

  static propTypes = {
    auth: PropTypes.object.isRequired,
    updateProfile: PropTypes.func.isRequired,
    resetRegisterEditProfileForm: PropTypes.func.isRequired,
    resetChangeEmailForm: PropTypes.func.isRequired,
    resetChangePasswordForm: PropTypes.func.isRequired,
    changeEmail: PropTypes.func.isRequired,
    changePassword: PropTypes.func.isRequired,
    profile: PropTypes.object.isRequired
  };

  static contextTypes = {
    userId: PropTypes.string.isRequired,
    location: PropTypes.object.isRequired
  };

  constructor (props) {
    super(props);
    this.state = {
      accepted: false
    };
  }

  componentWillMount () {
    const {
      profile: {
        firstName,
        lastName,
        phone,
        country,
        cityOrMunicipality,
        stateOrProvince,
        school,
        marketingOptIn,
        gettingStartedOptIn,
        directPromotionOptIn
      }
    } = this.props;
    this.props.resetRegisterEditProfileForm({
      firstName,
      lastName,
      phone,
      country,
      cityOrMunicipality,
      stateOrProvince,
      school,
      marketingOptIn,
      gettingStartedOptIn,
      directPromotionOptIn
    });
  }

  handleSubmit (data) {
    const { userId } = this.context;
    const {
      profile: {
        email: emailFromProfile
      },
      auth: {
        authData: {
          email: emailFromAuth
        }
      }
    } = this.props;
    return this.props.updateProfile(
      userId,
      {
        ...data,
        email: emailFromProfile || emailFromAuth
      }
    ).then(() => {
      this.setState({
        accepted: true
      });
    }).catch(() => {
      const errors = {
        alert: 'Oops, there was a problem updating your profile. Please try again!'
      };
      throw errors;
    });
  }

  render () {
    const { userId } = this.context;
    const {
      profile: {
        email: emailFromProfile
      },
      auth: {
        authData: {
          email: emailFromAuth
        }
      }
    } = this.props;
    const email = emailFromProfile || emailFromAuth;
    const { accepted } = this.state;
    if (!accepted) {
      return (
        <EditProfileForm
            userId={userId}
            email={email}
            resetChangeEmailForm={this.props.resetChangeEmailForm}
            resetChangePasswordForm={this.props.resetChangePasswordForm}
            changeEmail={this.props.changeEmail}
            changePassword={this.props.changePassword}
            onSubmit={::this.handleSubmit} />
      );
    } else {
      return <EditProfileSuccess />;
    }
  }

}



// WEBPACK FOOTER //
// ./src/views/auth/editProfile.jsx